<template>
  <el-dialog
    title="明细"
    :visible.sync="dialogVisible"
    width="70%"
    :before-close="handleClose">
    <div class="content" v-loading="loading">
      <el-row>
        <el-col :span="8">
          <span class="label">金额：</span>
          <span class="val">{{flowData.statusType === 1 ? '+' : '-'}}{{flowData.amount | decimal}}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">类型：</span>
          <span class="val">{{orderTypeMaps[flowData.type]}}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">时间：</span>
          <span class="val">{{flowData.createTime}}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">备注：</span>
          <span class="val">{{flowData.remark}}</span>
        </el-col>
      </el-row>
      <template v-if="flowData.type === 2 || flowData.type === 4 || flowData.type === 6">
        <div class="card" v-if="flowData.type && flowData.type === 6">
          <div class="card-header">关联售后订单</div>
          <div class="refund-order-list">
            <table class="refund-order">
              <tr>
                <th class="info">商品</th>
                <th>退款金额</th>
                <th>申请时间</th>
                <th>服务类型</th>
                <th>售后状态</th>
                <th>操作</th>
              </tr>
              <template v-for="order in orderList">
                <tr :key="order.asOid"><td colspan="6"></td></tr>
                <tr class="refund-order-header">
                  <td colspan="6">
                    <span class="mr-10">订单编号：{{ order.orderNumber }}</span>
                    <span class="mr-10">退款编号：{{ order.asOid }}</span>
                    <span>商家：{{ order.merchantName }}</span>
                  </td>
                </tr>
                <tr class="refund-order-content">
                  <td>
                    <div class="good clearfix" v-for="good in order.goodList" :key="good.bxysid">
                      <el-image class="good-cover fl" :src="good.goodImg"></el-image>
                      <div class="good-title u-line-two">{{ good.goodsName }}</div>
                      <div class="good-sku">{{ good.bxysName || '默认规格' }}</div>
                    </div>
                  </td>
                  <td>
                    <div>自付金额：￥{{ order.afterCashAmount | decimal }}</div>
                    <div>储值金额：￥{{ order.afterYhmoneyAmount | decimal }}</div>
                    <div>代金券金额：￥{{ order.afterVoucherAmount | decimal }}</div>
                  </td>
                  <td>{{ order.createTime }}</td>
                  <td class="amount">{{ order.returnType === 1 ? '退货退款' : '退款' }}</td>
                  <td class="state" :class="{
                      'red': order.status === 17,
                      'grey': order.status === 18,
                    }">{{ stateMaps[order.status] }}</td>
                  <td>
                    <el-link type="warning" @click="showRefundDetail(order)">服务详情</el-link>
                  </td>
                </tr>
              </template>
            </table>
          </div>
        </div>
        <div class="card" v-else>
          <div class="card-header">关联订单</div>
          <div class="orderbox_info" v-for="item in orderList" :key="item.oid">
            <div class="orderbox_info_header">
              <div>
                <p :class="{'waitPay': item.status===1}">{{ orderStatueMaps[item.status] }}</p>
                <span>{{ item.createTime }}</span>
                <el-divider direction="vertical"></el-divider>
                <span>{{ item.merchantName }}</span>
                <el-divider direction="vertical"></el-divider>
                <span>订单号： <i>{{ item.orderNumber }}</i></span>
              </div>
              <div class="order_money">
                订单金额：<i>{{ item.amount | decimal }}</i> 元
              </div>
            </div>
            <el-row class="order_goods_whole">
              <el-col :span="20">
                <div class="order-goods" v-for='goodsItem in item.orderCommodityList' :key="goodsItem.id">
                  <el-image :src="goodsItem.specificationImg || goodsItem.commodityImage" class="good-cover">
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                  <div class="good-info">
                    <p  @click="$tools.showGoodInBlank(goodsItem.commodityId)" class="good-name">{{ goodsItem.commodityName }}</p>
                    <p class="good-attr">{{ goodsItem.attributes }}</p>
                    <p class="good-price">{{ goodsItem.buyprice }} × {{ goodsItem.num || 1 }}</p>
                  </div>
                </div>
              </el-col>
              <el-col :span="4" class="btn-box">
                <el-button size="mini" @click="gotoDetail(item)">订单详情</el-button>
              </el-col>
            </el-row>
          </div>
        </div>
      </template>
    </div>
  </el-dialog>
</template>

<script type="text/ecmascript-6">
import { showorderList,backMoneyList } from '../../api/xunyou';
export default {
  name: 'yhFlowDetail',
  data() {
    return {
      dialogVisible: false,
      loading: false,
      flowData: '',
      orderList: [],
      orderTypeMaps: {
        1: '充值',
        2: '购物',
        3: '提现',
        4: '销售',
        5: '退货付款',
        6: '退货收款',
        7: '其他',
        8: '佣金',
        9: '人工调账',
        10: '冲正'
      },
      orderStatueMaps: {
        1: '等待买家付款',
        2: '等待卖家发货',
        3: '等待买家确认收货',
        4: '交易成功',
        5: '交易关闭',
        6: '退款待审核',
        7: '待财务审核',
        8: '等待卖家配货',
        9: '待评价',
        10: '已退单'
      },
      stateMaps: {
        11: '提交退单',
        12: '退单审核',
        13: '收货确认',
        14: '退款确认',
        15: '收款确认',
        16: '完成',
        17: '已拒绝退款',
        18: '已取消'
      }
    }
  },
  methods: {
    show (data) {
      this.flowData = data;
      if (this.flowData.type === 2) {
        this.getList(this.flowData.payFlowNo, '');
      }
      if (this.flowData.type === 4) {
        this.getList('', this.flowData.orderNumber);
      }
      if (this.flowData.type === 6) {
        this.getRefundOrderList(this.flowData.orderNumber);
      }
      this.dialogVisible = true;
    },
    hide () {
      this.dialogVisible = false;
    },
    handleClose (done) {
      this.flowData = '';
      this.orderList = [];
      done();
    },
    // 订单详情
    gotoDetail(order) {
      this.$router.push(`/myOrderDetail?orderNumber=${order.orderNumber}`)
    },
    // 售后详情
    showRefundDetail (order) {
      this.$router.push(`/refund?orderNo=${order.orderNumber}`);
    },
    getList(flowNo, orderNo) {
      if (!flowNo && !orderNo) return ;
      const params = {
        pageNum: 1,
        pageSize: 100,
        payFLowNo: flowNo,
        orderNumber: orderNo,
        muid: this.$store.getters.userId
      }
      this.loading = true;
      showorderList(params).then(res => {
        console.log('订单列表：', res);
        if (res.code === 0) {
          this.orderList = res.rows;
        }
      }).catch(err => {
        console.error('错误：', err);
      }).finally(() => {
        this.loading = false;
      })
    },
    getRefundOrderList(orderNo) {
      let params = {
        uid: this.$store.getters.userId,
        asOid: orderNo,
        pageNum: 1,
        pageSize: 100
      };
      this.loading = true;
      backMoneyList(params).then(res => {
        console.log('售后列表：', res);
        if (res.code === 0) {
          this.orderList = res.rows;
        }
      }).catch(err => {
        console.log('错误：', err);
      }).finally(() => {
        this.loading = false;
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" rel="stylesheet/less" scoped>
.card-header{
  font-weight: 500;
  margin-top: 20px;
}
.val{
  font-weight: 500;
}
.label{
  color: #888888;
}
.orderbox_info {
  margin-bottom: 10px;
  border: 1px solid #efefef;

  .orderbox_info_header {
    padding: 20px;
    box-sizing: border-box;
    border-bottom: 1px solid #efefef;
    display: flex;
    justify-content: space-between;
    p {
      font-size: 16px;
      margin-bottom: 5px;
    }

    .order_money i {
      font-size: 20px;
      color: var(--main-theme-color);
    }
  }
}
.order_goods_whole{
  padding: 20px;
  /deep/ .el-button+.el-button{
    margin-left: 0;
    margin-top: 5px;
  }
  .order-goods{
    display:flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 10px;
    .good-cover{
      width: 70px;
      height: 70px;
      margin-right: 10px;
      border-radius: 5px;
      border: 1px solid #F5F5F5;
    }
    .good-name{
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      &:hover{
        text-decoration: underline;
        color: #f47009;
      }
    }
    .good-attr{
      color: var(--main-theme-color);
      font-size: 12px;
    }
    .good-price{
      margin-top: 10px;
    }
  }
}
.refund-order{
  margin-top: 10px;
  width: 100%;
  .refund-order-header{
    padding: 0 20px;
    background: #EAF8FF;
    font-size: 12px;
    border: 1px solid #91CFFF;
    color: #3c3c3c;
    .chat-icon{
      padding: 0 5px;
      cursor: pointer;
      font-size: 14px;
      &:hover{
        color: var(--main-theme-color);
      }
    }
  }
  .refund-order-content{
    border: 1px solid #eeeeee;
  }
  th{
    background-color: #e9e9e9;
    padding: 10px;
    text-align: left;
  }
  td{
    padding: 10px;
  }
  .info{
    width: 350px;
  }
  .good-cover{
    width: 70px;
    height: 70px;
    border: 1px solid #F5F5F5;
    border-radius: 3px;
    margin-right: 10px;
  }
  .good-title{
    font-size: 14px;
    line-height: 1.3;
    margin-bottom: 10px;
    cursor: pointer;
    &:hover{
      color: var(--main-theme-color);
      text-decoration: underline;
    }
  }
  .amount{
    color: var(--main-theme-color);
  }
  .state{
    color: #0c80dc;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/siteNavigation/yhFlowDetail.vue